var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 128,
    viewBox: "0 0 136 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0121 102.017H16.9397V11.0723H0V0H44.9518V11.0723H28.0121V102.017ZM4.25859 7.00302H21.1037V98.0422H23.9427V7.00302H40.8825V4.25859H4.25859V7.00302Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.288 102.206L93.1212 38.6112C89.3358 59.9988 85.2665 81.9542 81.765 102.206H72.68L50.4407 0.189278H61.513L76.4654 68.0428C80.4401 45.1411 84.604 22.05 88.2948 0.189278H97.853L109.682 68.0428L124.256 0.189278H135.612L113.562 102.206H104.288ZM94.1622 4.2586H91.891L77.0332 89.809L58.1061 4.2586H55.551L75.9922 97.9476H78.0742L93.0266 13.9114L107.884 97.9476H110.156L130.313 4.2586H127.474L109.115 89.809L94.1622 4.2586Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M10.7884 127.474V118.673H7.19226V117.537H15.6148V118.673H12.1133V127.474H10.7884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M18.0753 127.474V117.537H21.3876C22.4285 117.537 23.2803 117.821 23.8481 118.389C24.4159 118.957 24.6998 119.619 24.6998 120.471C24.6998 121.133 24.5105 121.701 24.2266 122.174C23.8481 122.647 23.3749 123.026 22.7124 123.215L25.7408 127.474H24.2266L21.3876 123.404H19.5895V127.474H18.0753ZM19.4002 122.269H21.3876C22.05 122.269 22.5232 122.08 22.9017 121.796C23.1856 121.417 23.3749 121.039 23.3749 120.471C23.3749 119.998 23.1856 119.524 22.9017 119.146C22.6178 118.767 22.1446 118.673 21.3876 118.673H19.4002V122.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M27.9175 127.474V117.537H33.9741V118.673H29.2424V121.701H33.1224V122.837H29.2424V126.433H33.9741V127.568H27.9175V127.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M37.0024 127.474V117.537H37.7595L43.7216 125.013V117.537H44.9518V127.474H44.1947L38.3273 120.092V127.474H37.0024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M48.3586 127.474V117.537H51.4816C53.2797 117.537 54.6992 118.01 55.6456 118.957C56.5919 119.903 57.0651 121.039 57.0651 122.553C57.0651 124.067 56.5919 125.203 55.6456 126.149C54.6992 127.095 53.3743 127.568 51.4816 127.568H48.3586V127.474ZM49.6835 126.338H51.4816C52.9958 126.338 54.0368 125.96 54.6992 125.297C55.3617 124.635 55.6456 123.688 55.6456 122.553C55.6456 121.417 55.3617 120.471 54.6992 119.808C54.0368 119.146 52.9958 118.767 51.4816 118.767H49.6835V126.338Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M65.8662 127.474L62.4594 117.537H63.7842L66.1501 124.919C66.1501 125.013 66.2448 125.108 66.2448 125.297C66.2448 125.486 66.3394 125.581 66.3394 125.581C66.3394 125.486 66.434 125.297 66.5287 125.013L68.8946 117.632H69.7463L72.1122 125.013L72.3014 125.581C72.3014 125.297 72.3961 125.108 72.3961 125.013L74.7619 117.632H76.0868L72.68 127.568H71.8283L69.4624 120.755C69.4624 120.755 69.4624 120.66 69.3677 120.565C69.3677 120.471 69.2731 120.376 69.2731 120.376V120.282V120.376C69.2731 120.376 69.2731 120.565 69.1785 120.66C69.1785 120.755 69.1785 120.849 69.0838 120.849L66.7179 127.663H65.8662V127.474Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M76.2761 127.474L80.5347 117.537H81.3864L85.645 127.474H84.3201L83.1845 124.729H78.7366L77.601 127.474H76.2761ZM79.2098 123.594H82.7113L81.0079 119.43L79.2098 123.594Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M89.4305 127.474V118.673H85.929V117.537H94.3515V118.673H90.85V127.474H89.4305Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M100.692 127.663C99.1779 127.663 97.9476 127.19 96.9066 126.244C95.8656 125.297 95.3925 124.067 95.3925 122.458C95.3925 120.849 95.8656 119.619 96.9066 118.673C97.9476 117.726 99.1779 117.253 100.692 117.253C101.354 117.253 101.922 117.348 102.585 117.537C103.247 117.726 103.72 118.01 104.194 118.294V119.714C103.247 118.862 102.112 118.389 100.787 118.389C99.651 118.389 98.7047 118.767 97.9476 119.524C97.1905 120.282 96.9066 121.228 96.9066 122.458C96.9066 123.688 97.2852 124.635 98.0422 125.392C98.7993 126.149 99.7457 126.527 100.881 126.527C102.206 126.527 103.342 126.054 104.288 125.203V126.622C103.91 126.906 103.342 127.19 102.679 127.379C102.017 127.568 101.354 127.663 100.692 127.663Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M107.033 127.474V117.537H108.357V121.701H113.846V117.537H115.171V127.474H113.846V122.742H108.357V127.474H107.033Z",
    fill: "white"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/TW.80659e00ebb002141006f356fb52ef09.svg";
export { ForwardRef as ReactComponent };